
import { TextFieldHelper } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { Timer } from "@goodgamestudios/createjs-utilities";
import { Sine } from "gsap";
import { SFConstants } from "../../../constants/SFConstants";
import { Poker2LobbyDetailEvent } from "../../../event/Poker2LobbyDetailEvent";
import { Poker2TournamentDataEvent } from "../../../event/Poker2TournamentDataEvent";
import { AbstractLobbyDetailVO } from "../../../gamevo/AbstractLobbyDetailVO";
import { TournamentTablePlayerLineVO } from "../../../gamevo/TournamentTablePlayerLineVO";
import { TournamentTablesLobbyDetailVO } from "../../../gamevo/TournamentTablesLobbyDetailVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2TextFieldHelper } from "../../helper/Poker2TextFieldHelper";
import { PokerTextHelper } from "../../helper/PokerTextHelper";
import { ILobbyDetailComponent } from "./ILobbyDetailComponent";

import Container = createjs.Container;
import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;
import TimerEvent = createjs.TimerEvent;
import { TweenMaxGroup } from "../../helper/TweenMaxGroup";

export class TournamentTablesLobbyDetailComponent implements ILobbyDetailComponent {
    private UPDATE_DELAY: number = 30000;
    private NUM_PAYOUTS: number = 8;

    private TABLE_Y_HAS_SPECIAL_ITEM: number = 136.75;
    private TABLE_Y_HAS_NO_SPECIAL_ITEM: number = 77;

    private _holder: Container;
    private _view: Library.PokerInterface.LobbyTournamentTablesDetailView;
    private _updateTimer: Timer;
    private _currentPage: number = 0;
    private _vo: TournamentTablesLobbyDetailVO;
    private _tsg_fadeContent: TweenMaxGroup;
    private _contentMc: MovieClip;

    constructor(holder: Container, vo: TournamentTablesLobbyDetailVO) {
        this._holder = holder;
        this._vo = vo;
        this._view = new Library.PokerInterface.LobbyTournamentTablesDetailView();

        this._contentMc = this._view.mc_content;
        this._contentMc.alpha = 1;
        this._contentMc.mc_info.gotoAndStop(1);

        this.registerListeners();
        this.updateContent(false);

        //
        this.initUpdateTimer();
    }

    // tournament info update timer -> updates the tournament table every 30 seconds
    private initUpdateTimer(): void {
        this.stopTimer();
        this._updateTimer = new Timer(this.UPDATE_DELAY);
        this._updateTimer.addEventListener(TimerEvent.TIMER, this.bindFunction(this.updatePayout));
        this._updateTimer.start();
    }

    private updatePayout(event: TimerEvent): void {
        console.log("TournamentLobbyDetailComponent, updatePayout timer");
        var paramObject: any = { id: this._vo.id, update: true };
        BasicModel.smartfoxClient.sendMessage("jio", [JSON.stringify(paramObject)]);
    }

    private registerListeners(): void {
        this._view.btn_close.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
    }

    protected onClick(event: MouseEvent): void {
        switch (event.target.name) {
            case "btn_close":

                this.stopTimer();
                this.disposeTweenGroup(this._tsg_fadeContent);
                this._view.dispatchEvent(new Poker2LobbyDetailEvent("hideDetail", null, true));
                BasicController.getInstance().dispatchEvent(new Poker2TournamentDataEvent("blurSelectedTableLine"));
                break;
        }
    }

    public resetView(): void {

    }

    public enable(): void {

    }

    public disable(): void {
        this.stopTimer();
        this.disposeTweenGroup(this._tsg_fadeContent);
    }

    public destroy(): void {
        this.disable();
        this._view.btn_close.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
        this._view = null;
        this._vo = null;
    }

    private stopTimer(): void {
        if (this._updateTimer) {
            this._updateTimer.removeEventListener(TimerEvent.TIMER, this.bindFunction(this.updatePayout));
            this._updateTimer.stop();
            this._updateTimer = null;
        }
    }

    public update(lobbyDetailVO: AbstractLobbyDetailVO, transition: boolean): void {
        this._vo = lobbyDetailVO as TournamentTablesLobbyDetailVO;
        this.updateContent(transition);
    }

    private updateContent(transition: boolean = false): void {
        if (transition) {
            this.fadeOutContent();
        }
        else {
            // update view
            this.updateTexts();
            this.drawInfoLinesPlayers();
        }
    }

    private fadeOutContent(): void {
        this._contentMc.cacheAsBitmap = true;
        this._tsg_fadeContent = new TweenMaxGroup();
        this._tsg_fadeContent.to(this._contentMc, 0.2, { alpha: 0, ease: Sine.easeOut, onComplete: this.bindFunction(this.onFadeOutContentComplete) });
        this._tsg_fadeContent.play();
    }

    private onFadeOutContentComplete(): void {
        this.disposeTweenGroup(this._tsg_fadeContent);

        // update view
        this.updateTexts();
        this.drawInfoLinesPlayers();

        // fade in content
        this.fadeInContent();
    }

    private fadeInContent(): void {
        this._tsg_fadeContent = new TweenMaxGroup();
        this._tsg_fadeContent.to(this._contentMc, 0.3, { alpha: 1, ease: Sine.easeIn, onComplete: this.bindFunction(this.onFadeInContentComplete) });
        this._tsg_fadeContent.play();
    }

    private onFadeInContentComplete(): void {
        this._contentMc.cacheAsBitmap = false;
        this.disposeTweenGroup(this._tsg_fadeContent);
    }

    private updateTexts(): void {
        // header
        Poker2TextFieldHelper.changeTextFromatSizeByMaxHeight(9, this._contentMc.mc_header.txt_headline, Poker2Model.languageData.getTextById("lobby_detailedInfo_title") + " - " + this._vo.name);
    }

    private drawInfoLinesPlayers(): void {
        var startPos: number = this._currentPage * this.NUM_PAYOUTS;
        var infoLineArray: TournamentTablePlayerLineVO[] = this._vo.players;

        //			initArrows( infoLineArray.length );

        var i: number = 0;
        var len: number = startPos + this.NUM_PAYOUTS;
        for (i = startPos; i < len; ++i) {
            var currentItem: number = i - startPos;
            var infoLine: Library.PokerInterface.TournamentInfoLine = this._contentMc.mc_payOutTable["line" + currentItem] as Library.PokerInterface.TournamentInfoLine;

            if (i < infoLineArray.length) {
                var infoLineVO: TournamentTablePlayerLineVO = infoLineArray[i];
                infoLine.mouseChildren = false;

                // rank
                TextFieldHelper.changeTextFromatSizeByTextWidth(9, infoLine.txt_tables_0, infoLineVO.rank.toString());
                // level
                TextFieldHelper.changeTextFromatSizeByTextWidth(9, infoLine.txt_tables_1, infoLineVO.level.toString());
                // playername
                TextFieldHelper.changeTextFromatSizeByTextWidth(9, infoLine.txt_tables_2, infoLineVO.playerName);
                // chips
                infoLine.txt_tables_3.text = PokerTextHelper.getShortGroupNumberString(infoLineVO.chips);

                infoLine.visible = true;
            }
            else {
                infoLine.visible = false;
            }
        }

        if (infoLineArray.length == 0) {
            this._contentMc.mc_playersTable.mc_tableHeader.visible = false;
            return;
        }

        // table header text
        this._contentMc.mc_playersTable.mc_tableHeader.visible = true;
        Poker2TextFieldHelper.changeTextFromatSizeByMaxHeight(9, this._contentMc.mc_playersTable.mc_tableHeader.txt_headline, Poker2Model.languageData.getTextById("lobby_players"));
    }

    public disposeTweenGroup(tween: TweenMaxGroup): void {
        if (!tween) {
            return;
        }

        tween.destroy();
        tween = null;
    }

    public get view(): Container {
        return this._view;
    }
}
classImplementsInterfaces(TournamentTablesLobbyDetailComponent, "ILobbyDetailComponent");
